import { useFetch } from 'common/hooks/use-fetch';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getEnv } from 'selectors';
import { selectPageModelRegionId, selectPageModelStoreId } from 'store/pageModel';
import { formatPhone } from './lib/formatter';
import { GAShow } from 'utils';

export const useRoughWorkForm = () => {
	const storeId = Number(useSelector(selectPageModelStoreId));
	const regionId = Number(useSelector(selectPageModelRegionId));
	const { API_KEY_EXTERNAL, ORCHESTRATOR_EXTERNAL_HOST } = useSelector(getEnv);
	const [openModal, setOpenModal] = useState(false);
	const toggleModal = () => setOpenModal(prev => !prev);
	const [{ response, error, isLoading }, sendForm] = useFetch<{ leadId: string }>();
	const handleSendForm = useCallback(
		(contact: { name: string; phone: string }) => {
			sendForm({
				method: 'POST',
				url: `${ORCHESTRATOR_EXTERNAL_HOST}/experience/servicesplatform/plasterlanding/v1/leads`,
				headers: {
					'x-api-key': API_KEY_EXTERNAL,
				},
				data: {
					regionId,
					storeId,
					type: 'PLASTER',
					channel: 'LANDING',
					contact: { ...contact, phone: formatPhone(contact.phone) },
				},
			});
		},
		[API_KEY_EXTERNAL, ORCHESTRATOR_EXTERNAL_HOST, regionId, sendForm, storeId]
	);

	const currentStatus = useMemo(() => {
		if (error) {
			if (!response?.leadId && error?.data.message.includes('109')) return 'duplicate';
			return 'error';
		}
		if (response?.leadId) return 'success';
		return 'success';
	}, [error, response]);

	useEffect(() => {
		if (error || response) {
			GAShow({
				elementBlock: 'landingChernovoyRemont',
				elementName: 'requestSentSuccessful',
				elementText: 'Заявка на бесплатную консультацию',
				elementRegistrationId: response?.leadId || 'error',
			});
			toggleModal();
		}
	}, [error, response]);

	const fetched = !!response;

	return {
		handleSendForm,
		toggleModal,
		openModal,
		currentStatus,
		isLoading,
		fetched,
	};
};
